var _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEllipsisHorizontal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 9.5,
    r: 1.5,
    transform: "rotate(90 13.5 9.5)",
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 1.5,
    transform: "rotate(90 9 9.5)",
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 1.5,
    transform: "rotate(90 4.5 9.5)",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEllipsisHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ellipsis-horizontal.3cb6495614a095da5cfcf9acf90a3341.svg";